import { render, staticRenderFns } from "./rulesCombination.vue?vue&type=template&id=bafaef78&"
import script from "./rulesCombination.vue?vue&type=script&lang=js&"
export * from "./rulesCombination.vue?vue&type=script&lang=js&"
import style0 from "./rulesCombination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bafaef78')) {
      api.createRecord('bafaef78', component.options)
    } else {
      api.reload('bafaef78', component.options)
    }
    module.hot.accept("./rulesCombination.vue?vue&type=template&id=bafaef78&", function () {
      api.rerender('bafaef78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/SingleRule/AddSingleRuleDialog/rulesCombination.vue"
export default component.exports